export const getCurrentProgress = (e, seek, audio) => {
  const progressBarRect = seek.getBoundingClientRect();
  const maxRelativePos = progressBarRect.width;
  let relativePos = getPosX(e) - progressBarRect.left;
  if (relativePos < 0) {
    relativePos = 0;
  } else if (relativePos > maxRelativePos) {
    relativePos = maxRelativePos;
  }
  const duration = audio.duration;
  const currentTime = (duration * relativePos) / maxRelativePos;
  return { currentTime };
};
export const getPosX = (event) => {
  if (event instanceof MouseEvent) {
    return event.clientX;
  } else {
    return event.touches[0].clientX;
  }
};
